import Loop from '../assets/svgs/loop.svg';
import skipped from '../assets/svgs/skipeed.svg';
import complete from '../assets/svgs/complete-movex.svg';

// this points for joints that come from media pipe
export const pointsConnections = [
  [0, 1],
  [1, 2],
  [2, 3],
  [3, 7],
  [0, 4],
  [4, 5],
  [5, 6],
  [6, 8],
  [9, 10],
  [11, 12],
  [11, 13],
  [13, 15],
  [15, 17],
  [15, 19],
  [15, 21],
  [17, 19],
  [12, 14],
  [14, 16],
  [16, 18],
  [16, 20],
  [16, 22],
  [18, 20],
  [11, 23],
  [12, 24],
  [23, 24],
  [23, 25],
  [24, 26],
  [25, 27],
  [26, 28],
  [27, 29],
  [28, 30],
  [29, 31],
  [30, 32],
  [27, 31],
  [28, 32],
];

// MediaPipe Pose landmarks 0-10 are all facial: nose (0), the six eye points
// (1-6), the ears (7-8) and the mouth corners (9-10). The live skeleton overlay
// skips them so nothing is drawn over the person's face — every other consumer
// (scoring payload, debug canvas) still gets the full 33-point set.
export const FACE_LANDMARK_INDICES = Object.freeze([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);

export const isFaceLandmarkIndex = index => FACE_LANDMARK_INDICES.includes(index);

export const dataJsonMessage = {
  movement: 'squat',
  patterns: null,
  sections: null,
  configuration: {
    numberOfSets: 1,
    pacing: -1,
    percentageCorrectness: 70,
    reps: 5,
    restBetweenSets: 15,
    side: 'null',
    time: -1,
  },
};

export const colors = {
  primary: '#121212',
  secondary: '#6A7920',
};

// Only used when the backend omits `introResult.introInterval` — the real
// value always wins, this just keeps the intro ring counting instead of
// sitting on a NaN scale.
export const DEFAULT_INTRO_INTERVAL_SECONDS = 5;

export const STAGE_STATUS = {
  INTRO: 1,
  IN_PERFORMANCE: 2,
  REST: 3, // rest between sets stage
  EXERCISES_DONE: 4,
  POST_PERFORMANCE: 5,
};

export const TimerStates = {};
export const Exercises = {};
export const setStatus = {};

// export const setStatus = {
//   SET_IS_RUNNING: 0,
//   SET_IS_FINISHING: 1,
// };

export const FeedBackSTatus = {
  SET_IS_NOT_FINISHING: 0,
  SET_IS_FINISHING: 1,
};

// export const TimerStates = {
//   HIde: 0,
//   SHOW: 1,
// };

// export const version = "?v=2";

// export const POST_PERFORMANCE_BORDER_COLOR = {
//   green: 1,
//   red: 2,
// };

export const PACING_MARGIN = 1;

export const termsList = [
  { id: 0, title: '', content: '' },
  {
    id: 1,
    title: 'Registration and Profile',
    content:
      'To use the Services, account registration is required. You must provide accurate and up-to-date information during registration. Keep your account details, including your username and password, confidential. Notify us immediately if you notice any unauthorized use of your account. Kinematician reserves the right to delete inactive accounts or terminate accounts that do not comply with these Terms. ',
  },
  {
    id: 2,
    title: 'Capturing and Utilizing Your Photos or Videos',
    content:
      'By using the Services, you agree to allow Kinematician to record and store your exercise data. Kinematician saves videos or images of your exercises. Kinematician is not responsible for any loss or damage to saved videos. If your saved videos feature other individuals, you must obtain their consent. We may utilize your videos to enhance our Services and adhere to legal requirements.',
  },
  {
    id: 3,
    title: 'User Restrictions',
    content:
      'You agree to utilize the Services solely for exercise purposes and abstain from engaging in any illegal or unauthorized activities. It is essential to respect the rights of other users, refrain from gathering personal information without consent, and avoid misusing the content provided on the Platform. Furthermore, linking or framing Platform content is prohibited without prior permission.',
  },
  {
    id: 4,
    title: 'Exercise Activity Disclaimer',
    content:
      'The Platform includes features that support physical activity. Consult a healthcare professional before engaging in any physical activity. Kinematician is not a medical provider and is not liable for any injuries or damage resulting from your use of the Platform.',
  },
  {
    id: 5,
    title: 'Intellectual Property Rights',
    content:
      'Kinematician holds all intellectual property rights associated with the Platform and Services. Unauthorized use of these rights is strictly forbidden. Any feedback provided by users grants Kinematician an irrevocable license to incorporate it into future products or services.',
  },
  {
    id: 6,
    title: 'Cancellation',
    content:
      'These Terms will remain in effect until either party terminates them. Kinematician reserves the right to restrict or terminate your access if you do not comply with them. Upon termination, you must stop using the Platform and Services.',
  },
  {
    id: 7,
    title: 'Delegation',
    content:
      'These Terms are specific to you and cannot be transferred. Kinematician may transfer these Terms without prior notice.',
  },
];

export const screenSizes = {
  sm_custom: 600,
  sm: 640,
  md: 768,
  md_custom: 900,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

export const FeedBackStepsNumber = {
  'there Error Text turn': 0,
  'compare with creator text turn': 1,
  'user movement text turn': 2,
  'creator movemet text turn': 3,
  'redo text turn': 4,
};

export const rectangleFlag = {
  none: 0,
  yellow: 1,
  red: 2,
  green: 3,
};

// How a set ends, stated by the backend as `type` on every stage payload. This
// replaces the retired `exercise_mode` / "Fixed Reps" / "Fixed Time" vocabulary:
// a retired value is never sent and never translated.
//   REP_BASED   — ends on the rep count
//   TIMED_REPS  — ends on the clock, reps still counted
//   TIMED_HOLD  — the hold *is* the set, so no rep counter exists at all
export const exerciseType = {
  repBased: 'REP_BASED',
  timedReps: 'TIMED_REPS',
  timedHold: 'TIMED_HOLD',
};

// Per exercise, not per session — one session may mix the two. Replaces the old
// session-level camera boolean and the `OFFLINE` spelling.
export const executionMode = {
  motionCapture: 'MOTION_CAPTURE',
  noMotionCapture: 'NO_MOTION_CAPTURE',
};

export const settingStatus = {
  1: 'Not-started',
  2: 'On-going',
  3: 'In-complete',
  4: 'Skipped',
  5: 'Completed',
};

export const iconSettingStatus = {
  1: 'none',
  2: Loop,
  3: 'none',
  4: skipped,
  5: complete,
};

export const ButtonsStatus = {
  1: 'Start',
  2: 'Redo',
  3: 'Restart',
};

export const SettingMode = {
  pause: 1,
  start: 2,
  restart: 3,
  redo: 4,
  skip: 5,
  restartSession: 6,
  // Action 7 toggles the mode of one exercise and carries `executionMode`.
  mediaPipeToggle: 7,
  executionModeToggle: 7,
  // Ends the between-set REST early. There is no exit action — exit is
  // disconnect-only: close the socket and the backend runs its exit handling.
  skipRest: 8,
  skipRestart: 8,
};

export const SettingModeKeys = {
  1: 'pause',
  2: 'start',
  3: 'restart',
  4: 'redo',
  5: 'skip',
  6: 'restartSession',
  7: 'mediaPipeToggle',
};

// `action_type` values for the INPERFORMANCE_ACTION Mixpanel event —
// one entry per patient-initiated action in the in-performance flow.
export const IN_PERFORMANCE_ACTION_TYPES = {
  EXERCISE_NOW: 'exercise now',
  PAUSE_SESSION: 'pause session',
  RESUME_SESSION: 'resume session',
  SHOW_EXERCISE_DETAILS: 'show exercise details',
  RESTART_EXERCISE: 'restart exercise',
  SKIP_EXERCISE: 'skip exercise',
  COMPLETE_LATER: 'complete later',
  SKIP_REST: 'skip rest',
};
